<style lang="scss" scoped>
    .remark {
        font-size: toRem(18px);
        line-height: lh(34px, 18px);
        letter-spacing: 7.88px;
        color: $white;

        @include above(md) {
            font-size: toRem(35px);
            line-height: lh(72px, 35px);
        }
    }
</style>
<template>
    <div class="remark">
        {{ copy }}
    </div>
</template>
<script>
export default {
    name: 'Remark',
    props: {
        copy: {
            type: String,
            required: true,
        },
    },
}
</script>
